import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import {
  Modal,
  ModalFooter,
  ModalBody,
  Button,
  Row,
  Col,
} from 'reactstrap';

import IconClose from '../../images/cross.png';

class ModalHistoryShipping extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      _selectedItem: null,
      isFetched: false,
    }
    this.renderAddress = this.renderAddress.bind(this);
    this.onSubmitShipping = this.onSubmitShipping.bind(this);
    this.onAddingNewShipping = this.onAddingNewShipping.bind(this);

    this.chooseShipping = this.chooseShipping.bind(this);
  }

  onAddingNewShipping() {
    this.props.onChooseShipping('NEW_SHIPPING')
  }

  onSubmitShipping() {
    const { provinces } = this.props.dataPostalCode;
    let selectedItem = this.state._selectedItem;
    let checkingIdProvince = provinces.data.filter((a, index) => {
      return a.name === selectedItem.province
    })

    this.props.onChooseShipping({...selectedItem, id_province: checkingIdProvince[0].id})

  }

  chooseShipping(e) {
    this.setState({
      _selectedItem: e
    })
  }

  componentDidUpdate() {
    const { shippingHistory } = this.props.dataPostalCode;
    if (shippingHistory.data.length !== 0 && !shippingHistory.isFetch && this.state.isFetched) {
      this.setState({
        isFetched: false,
        _selectedItem: shippingHistory.data[0]
      })
    }
  }

  componentDidMount() {
    this.setState({
      isFetched: true
    })
  }

  renderAddress() {
    const { shippingHistory } = this.props.dataPostalCode;
    return (
      <div className="modal__shipping_content_option">
        {
          shippingHistory.data.map((item, index) => (
            <div key={index} className="modal__shipping_content_history_shipping">
              <Row
                className="modal__shipping_wrapping_content"
                onClick={() => this.chooseShipping(item) }
              >
                <Col md="2" className="content_bullet">
                  <div className="option__icon">
                    <div className={this.state._selectedItem != null && this.state._selectedItem.id === item.id ? 'option__icon_point' : null} />
                  </div>
                </Col>
                <Col md="10" className="content_value">
                  <p>{item.alias === null ? '-' : item.alias}</p>
                  <p>{item.full_name}</p>
                  <p>{item.street_address}</p>
                  <p>{item.city}</p>
                  <p>{item.postal_code}</p>
                </Col>
              </Row>
          </div>
          ))
        }
      </div>
    )
  }

  render () {
    const { shippingHistory } = this.props.dataPostalCode;
    return (
      <Modal
        style={{
          height: 500,
          marginTop: 150
        }}
        isOpen={this.props.isOpen}
        toggle={this.props.onToggle}
        contentClassName="content-search content__filter"
        className="kick-modal">
          <div className="modal__shipping">
            <div>
              <Row>
                <Col className="item-modal-active" onClick={() => this.props.closeModalShipping() } >
                  <KickImage className="btn-close-modal close-modal_filter" onClick={this.props.toggleModalSearch} src={IconClose} alt="close filter"/>
                </Col>
              </Row>
            </div>
            <div className="modal__shipping_content">
              <div className="modal__shipping_content_border">
                <div className="modal__shipping_content_header">
                  <p>Pilih Alamat Pengiriman</p>
                </div>
                {
                  shippingHistory.data.length === 0 ?
                  <h3>Silahkan tunggu...</h3>
                  :
                  this.renderAddress()
                }
              </div>
              <ModalFooter style={{ background: '#fff' }} className="modal__shipping_footer">
               <a href="#" onClick={this.onAddingNewShipping}>Tambahkan Alamat Baru</a>
               <Button
                 className="modal__shipping_btn"
                 color="primary" onClick={this.onSubmitShipping}>LANJUTKAN</Button>
             </ModalFooter>
            </div>
          </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  dataPostalCode: state.dataPostalCode
})

export default connect(mapStateToProps, null)(ModalHistoryShipping);
